export const AUTHOR = "Aishwarya Rajeev";
export const FILTERS_CATEGORY = [
  "Launch Year",
  "Successful Launch",
  "Successful Landing",
];
export const ACTION_CATEGORY = {
  "Launch Year": "launch_year",
  "Successful Launch": "launch_success",
  "Successful Landing": "land_success",
};

export const CARD_TITLES = ["Mission Ids", ...FILTERS_CATEGORY];

export const BOOLEAN_BUTTONS = ["True", "False"];
